var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 99,
    viewBox: "0 0 107 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.861 24.8704L86.994 0.450195H36.084L55.9513 24.8704L36.084 49.2906L16.2168 24.8704L36.084 0.450195H10.836L-9.03125 24.8704L10.836 49.2906L-9.03125 73.7108L10.836 98.131H61.9529L41.8786 73.7108L61.9529 49.2906L81.8202 73.7108L61.9529 98.131H86.994L106.861 73.7108L86.994 49.2906L106.861 24.8704Z",
    fill: "#2029DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo8);
export default __webpack_public_path__ + "static/media/logo8.c98aac67e5085b5f952eef2de280a19d.svg";
export { ForwardRef as ReactComponent };